module.exports = __webpack_public_path__ + "img/currency7.8390cb31.png";